<template lang="pug">
    #mutipleFile.v-container(class="pa-0")
        //- 已選取預覽清單
        v-row.previewCard(dense v-if="filesPreview.length > 0")
            v-col.previewCardFile(v-for="(file, k) in filesPreview" :key="k" cols="auto")
                v-card.file-tab(
                    flat
                    class="pa-0 d-flex align-center justify-space-between" 
                    )
                    div.d-flex.align-center.flex-grow-1.text-truncate.ellipsis
                        v-avatar(tile size='33')
                            v-img(:src="getFileIcon(file.previewName)" max-width="20px" width="20px" height="20px") 
                        //- slot(:file="file")
                        //- input(
                        //-     ref="fileInput"
                        //-     type="file"
                        //-     class="d-none"
                        //-     :accept="accept"
                        //-     @change="uploadDocument($event, k, 'reset')"
                        //- )
                        //- v-spacer
                        div.py-1.mr-2.ellipsis(:title="file.previewName") {{file.previewName}}
                    v-btn.px-0.ml-auto.flex-shrink-0.text-none(
                        v-show="isVisable"
                        depressed
                        plain
                        min-width='30'
                        :disabled="isUploading"
                        @click.stop="removeFile(file, k)"
                    ) 
                        v-icon(size='14')  mdi-close
        //- add, drop Area
        v-card.add-drop-area(
            v-if="isVisable"
            flat
            :class="['mt-2 pa-4 d-flex align-center justify-center', {'not-add-status-bg': !canAddMore}, {'dragging-status-bg': isDraggingOver}]"
            @click="selectFiles"
            @dragover.prevent="handleDragOver($event, filesPreview.length, 'add')"
            @dragleave.prevent="handleDragLeave($event, filesPreview.length, 'add')"
            @drop="handleDrop($event, filesPreview.length, 'add')"
        )
            div(class="text-center")
                slot()
                div(v-if="isUploading" class="caption grey--text mt-2") {{$t('AGENT_FILE_ATTACHMENT.UPLOADING')}}
                div(v-else-if="!canAddMore" class="caption grey--text mt-2") {{$t('AGENT_FILE_ATTACHMENT.EXCEED_MAX')}}
                div(v-else class="caption grey--text mt-2") {{$t('AGENT_FILE_ATTACHMENT.UPLOAD')}} {{$t('AGENT_FILE_ATTACHMENT.ACCEPT_TYPE', { file_type: file_type_text })}}
            input(
                ref="newfilesInput"
                type="file"
                class="d-none"
                multiple
                :accept="accept"
                @change="uploadDocument($event, filesPreview.length, 'add')"
            )
            v-progress-linear(
                v-if="isUploading"
                height="4"
                striped
                indeterminate
                absolute
                bottom
            )
        v-snackbar(
            v-model="errorAlertVisible"
            color="error"
            timeout="3500"
        ) {{ errorMessage }}
</template>

<script>
import i18n from '/common/plugins/vue-i18n.js';

export default {
    name: 'MultipleFile',
    props:{
        accept: {
            type: String
        },
        mode: {
            type: String
        },
        uploadBtnText: {
            type: String,
            default: 'Upload'
        },
        progressBtnText: {
            type: String,
            default: 'Uploading...'
        },
        uploadedFiles: {
            type: Array,
            default: () => [],
            required: true
        },
        callback: {
            type: Function,
        },
        isUploading: {
            type: Boolean,
            default: false
        },
        schedule_access: {
            type: Boolean,
            default: false
        },
        isVisable: {
            type: Boolean,
            default: true
        },
    },
    data(){
        return {
            isDragging: false,
            uploading: false,
            isDeleting: false,
            isDraggingOver: false,
            errorAlertVisible: false,
            errorMessage: 'Something went wrong',
            settingSavedSuccess: false,
            filesPreview: [],
            files: [],
            Max_files: 3,
            file_type_text: this.accept.replaceAll(',', '')
        }
    },
    mounted(){
        if(this.uploadedFiles) {
            for(let i=0; i<this.uploadedFiles.length; i++){
                this.filesPreview.push({
                    previewType: this.uploadedFiles[i].file_type,
                    previewUrl: this.uploadedFiles[i].full_file_path,
                    previewName: this.uploadedFiles[i].name,
                    isDragging: false
                })
                this.files.push({
                    file_type: this.uploadedFiles[i].file_type,
                    full_file_path: this.uploadedFiles[i].full_file_path,
                    name: this.uploadedFiles[i].name
                })
            }
        }
    },
    methods: {
        async uploadingFunction(){
            if(this.files.length > 0){
                this.isUploading = true;
                try {
                    await this.callback(this.files);
                    this.filesPreview = [];
                    this.files = [];
                    if(this.uploadedFiles){
                        for(let i=0; i < this.uploadedFiles.length; i++){
                            this.filesPreview.push({
                                previewType: this.uploadedFiles[i].file_type,
                                previewUrl: this.uploadedFiles[i].full_file_path,
                                previewName: this.uploadedFiles[i].name,
                                isDragging: false
                            })
                            this.files.push({
                                file_type: this.uploadedFiles[i].file_type,
                                full_file_path: this.uploadedFiles[i].full_file_path,
                                name: this.uploadedFiles[i].name
                            })
                        }
                    }
                } catch(e){
                    this.errorMessage = 'Upload failed';
                    this.errorAlertVisible = true;
                } finally {
                    this.isUploading = false;
                }
            }
        },
        // edit certain file
        selectFile(index){
            if(this.isUploading) return
            const fileInputs = this.$refs.fileInput || [];
            const fileInput = Array.isArray(fileInputs) ? fileInputs[index] : null;
            if(fileInput) fileInput.click();
        },
        selectFiles(){
            if(this.isUploading) return;
            if(!this.canAddMore){
               return 
            }
            const fileInputRef = this.$refs.newfilesInput;
            if(fileInputRef) fileInputRef.click()
        },
        add(previewType, previewUrl, previewName, isDragging){
            this.filesPreview.push({
                previewType,
                previewUrl,
                previewName,
                isDragging
            })
        },
        update(previewType, previewUrl, previewName, isDragging, index){
            this.$set(this.filesPreview, index, {previewType, previewUrl, previewName, isDragging})
        },
        async removeFile(file, index) {
            if (this.isUploading || this.isDeleting) return
            
            // 從 previewUrl 是否為 null 判斷是否本地檔（尚未上傳）
            if(!file.previewUrl){
                this.filesPreview.splice(index, 1);
                this.files.splice(index, 1);
                return
            }
            else{
                // 已上傳檔案
                this.isDeleting = true;
                let data_file = this.files[index];
                // console.log('index', index)
                // console.log('data_file', this.files, this.files[index])
                this.$emit("editDeleteFile", data_file)
  
                this.isDeleting = false;
                // UI 刪除
                this.filesPreview.splice(index, 1)
                this.files.splice(index, 1)
            }
        },
        async uploadDocument(event, index, action) {
            if (this.isUploading) return
            const files = event.target.files || [];
            // console.log("加入的數量", files.length)
            // console.log("原始資料的數量", this.files.length)

            const acceptList = this.accept  ? this.accept.split(',').map(ext => ext.trim().toLowerCase()) : null;

            let fileQuota = 0;
            fileQuota = this.files.length + files.length;
            if(fileQuota > this.Max_files){
                this.$emit("showErrorDialog", i18n.t('AGENT_FILE_ATTACHMENT.EXCEED_MAX'))
                // add 狀態復原為空
                if(this.mode == 'add'){
                    this.files = [];
                    this.filesPreview = [];
                }
                // 計數歸零
                fileQuota = 0;
                event.target.value = ''
                return
            }
            try{
                // 針對每個檔案呼叫 previewFile，收集 Promise
                const promises = []
                for(let i = 0; i < files.length; i++){
                    let fileName = files[i].name.toLowerCase();
                    let fileExt = '.' + fileName.split('.').pop();
                    try {
                        if (!acceptList || acceptList.includes(fileExt)) {
                            // previewFile 會回傳 Promise，resolve 表示 preview 完成並把 data push 到 this.files / this.filesPreview
                            promises.push(this.previewFile(files[i], index + i, action))
                        }else{
                            this.$emit("showErrorDialog", i18n.t('AGENT_FILE_ATTACHMENT.WRONGTYPEINFILE'))
                        }
                    } catch (error) {
                        console.error('error : ', error)
                    }
                }
                // 等所有 FileReader 完成
                await Promise.all(promises)
                if (action !== 'reset') {
                    if (!this.schedule_access) {
                        this.$emit("saveFiles", this.files);
                    } else {
                        this.$emit("addAttachmentData", this.files);
                    }
                }
            } finally {
                event.target.value = ''
            }
        },
        previewFile(file, index, action){
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.onload = ()=> {
                    const obj = {
                        previewType: file.type,
                        previewUrl: null,
                        previewName: file.name,
                        isDragging: false
                    }

                    if (action === 'reset') {
                        this.update(obj.previewType, obj.previewUrl, obj.previewName, obj.isDragging, index);
                        this.$set(this.files, index, file);
                    } else {
                        // 加入 filesPreview
                        this.add(obj.previewType, obj.previewUrl, obj.previewName, obj.isDragging); 
                        // 加入 file
                        this.files.push(file);
                    }
                    resolve()
                }
                reader.onerror = (error) => {
                    console.error(`Error reading file ${file.name}: ${error}`)
                    reject(error)
                }
                reader.readAsDataURL(file)
            })
        },
        handleDragOver(event, index, action) {
            if (this.isUploading) return
            event.preventDefault()
            this.isDraggingOver = true
            if(action === 'add' && !this.canAddMore) return 
            if (action === 'reset') {
                if (this.filesPreview[index]) this.filesPreview[index].isDragging = true
            }else{
                this.isDragging = true
            }
        },
        handleDragLeave(event, index, action) {
            event.preventDefault()
            this.isDraggingOver = false
            if (action === 'reset') {
                if (this.filesPreview[index]) this.filesPreview[index].isDragging = false
            } else {
                this.isDragging = false
            }
        },
        handleDrop(event, index, action) {
            if (this.isUploading) return
            if(!this.canAddMore){
               return 
            }
            event.preventDefault()
            this.isDraggingOver = false
            if (action === 'reset') {
                if (this.filesPreview[index]) this.filesPreview[index].isDragging = false
            }else{
                this.isDragging = false
            }
            const dropped = (event.dataTransfer && event.dataTransfer.files) ? event.dataTransfer.files : [];
            // console.log('[DRAPFILE]', dropped)
            const acceptList = this.accept  ? this.accept.split(',').map(ext => ext.trim().toLowerCase()) : null;
            // console.log("DRAG的數量", dropped.length)
            // console.log("原始資料的數量", this.files,this.files.length)
            // console.log("UI原始資料的數量", this.filesPreview.length)
            let fileQuota;
            fileQuota = this.files.length + dropped.length;
            console.log("=====", fileQuota)
            if(fileQuota > this.Max_files){
                this.$emit("showErrorDialog", i18n.t('AGENT_FILE_ATTACHMENT.EXCEED_MAX'))
                if(this.mode == 'add'){
                    this.files = [];
                    this.filesPreview = [];
                }
                fileQuota = 0;
                return
            }
            const promises = []
            for (let i = 0; i < dropped.length; i++) {
                let fileName = dropped[i].name.toLowerCase();
                let fileExt = '.' + fileName.split('.').pop();
                try {
                    if (!acceptList || acceptList.includes(fileExt)) {
                        promises.push(this.previewFile(dropped[i], index + i, action))
                    }
                } catch (error) {
                    console.error('error : ', error)
                }
            }
            Promise.all(promises)
            .then(()=>{
                if (action !== 'reset') {
                    if (!this.schedule_access) {
                        // console.log('一次性 emit saveFiles', this.files)
                        this.$emit("saveFiles", this.files);
                    } else {
                        // console.log('一次性 emit addAttachmentData', this.files)
                        this.$emit("addAttachmentData", this.files);
                    }
                }
            }).catch((err) => {
                this.$emit("showErrorDialog", String(err))
            })
        },
        _isLocalFile(idx){
            return this.files[idx] instanceof File;
        },
    },
    computed: {
        canAddMore(){
            return this.filesPreview.length < this.Max_files
        }
    },
    watch:{
        uploadedFiles: {
            handler(newVal) {
                this.filesPreview = [];
                let update_file = []

                for(let i=0; i<newVal.length; i++){
                    this.filesPreview.push({
                        previewType: newVal[i].file_type,
                        previewUrl: newVal[i].full_file_path,
                        previewName: newVal[i].name,
                        isDragging: false
                    })
                    update_file.push({
                        file_type: newVal[i].file_type,
                        full_file_path: newVal[i].full_file_path,
                        name: newVal[i].name
                    })
                }
                this.files = update_file;
            },
            deep: true
        },
    }
}
</script>